import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'


export default function ProductSurgeryReportForm({ location }) {
  console.log('ProductSurgeryReportForm rendered: ', location)

  let init = {
    reportType: 'ME'
  }

  const navigate = useNavigate()
  init = initialFormValues('ProductSurgeryReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('ProductSurgeryReportForm', navigate, inputs, 'product_surgery.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Product Surgery by Year Reports' />
            <tbody>
              <tr>
                <td><b>Report Type</b></td>
                <td>
                  <Input
                    type="select"
                    name="reportType"
                    onChange={handleInputChange}
                    style={{width: 'auto', display: 'inline-block', marginRight: '5px'}}
                    defaultValue={inputs.reportType}
                  >
                    <option value={'ME'}>Manually Entered</option>
                    <option value={'I'}>Inventory</option>
                    <option value={'SHB'}>SHB</option>
                    <option value={'ALL'}>All Sources</option>
                    <option value={'UME'}>Uphold (Manually Entered)</option>
                    <option value={'UI'}>Uphold (Inventory)</option>
                    <option value={'USHB'}>Uphold (SHB)</option>
                    <option value={'UALL'}>Uphold (All Sources)</option>
                  </Input>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

